import type { SVGProps } from 'react';
const SvgCardTravel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#card_travel_svg__a)">
      <path
        fill="currentColor"
        d="M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2ZM9 4h6v2H9V4Zm11 15H4v-2h16v2Zm0-5H4V8h3v2h2V8h6v2h2V8h3v6Z"
      />
    </g>
    <defs>
      <clipPath id="card_travel_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCardTravel;
